<template>
  <div class="impersonation-pill">
    <strong class="account-name">{{ store.impersonation.accountName }}</strong>
    <span class="timer">{{ timeRemaining }}</span>
    <button class="exit-btn" @click="handleExit">
      <vue-feather type="x" size="14" />
    </button>
  </div>
</template>

<script>
import { store, clearImpersonation } from '../../store'
import VueFeather from 'vue-feather'

export default {
  name: 'ImpersonationBanner',
  components: { 'vue-feather': VueFeather },
  data() {
    return {
      store,
      now: Date.now(),
      tickInterval: null
    }
  },
  computed: {
    timeRemaining() {
      if (!store.impersonation.expiresAt) return '--:--'
      const diff = store.impersonation.expiresAt - this.now
      if (diff <= 0) return '0:00'
      const minutes = Math.floor(diff / 60000)
      const seconds = Math.floor((diff % 60000) / 1000)
      return `${minutes}:${seconds.toString().padStart(2, '0')}`
    }
  },
  watch: {
    timeRemaining(val) {
      if (val === '0:00') {
        alert('Impersonation session has expired.')
        this.handleExit()
      }
    }
  },
  mounted() {
    this.tickInterval = setInterval(() => {
      this.now = Date.now()
    }, 1000)
  },
  beforeUnmount() {
    if (this.tickInterval) clearInterval(this.tickInterval)
  },
  methods: {
    handleExit() {
      clearImpersonation()
      this.$router.push('/admin/accounts')
    }
  }
}
</script>

<style scoped>
.impersonation-pill {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #1a1a2e;
  color: #fff;
  border-radius: 50px;
  padding: 8px 10px 8px 16px;
  font-size: 0.8125rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
}

.account-name {
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.timer {
  font-variant-numeric: tabular-nums;
  opacity: 0.6;
  font-size: 0.75rem;
  white-space: nowrap;
}

.exit-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
}

.exit-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.exit-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

@media screen and (max-width: 1000px) {
  .impersonation-pill {
    bottom: 64px;
  }
}

/* Bottom bar occupies the strip below 700px — lift the pill clear of it. */
@media screen and (max-width: 700px) {
  .impersonation-pill {
    bottom: calc(20px + var(--app-mobile-nav-total));
  }
}
</style>
